import React from 'react';
import PropTypes from 'prop-types';
import { Curious } from '@curi/react';
import { Helmet } from 'react-helmet';
import PageHeader from '../../components/global/PageHeader';
import './Homeschool.css';
import { gtmPageviewEvent } from '../../services/google-tag-manager';
const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

class Homeschool extends React.PureComponent {
    componentDidMount() {
        gtmPageviewEvent({
            pageName: 'codespark.com: Homeschool',
            componentProps: this.props,
        });
    }

    render() {
        return (
            <div className="about-page page">
                <Helmet>
                    <title>Homeschool | codeSpark</title>
                    <meta name="description" content="codeSpark’s mission is to make computer science education accessible to kids everywhere." />
                    <meta name="keywords" content="Kids coding languages, Hour of code, coding for kids, kids apps, kids games, learn to code, STEM, Reading, Math, Elementary school" />
                    <meta property="og:title" content="Coding Game for Kids - Try it Free!" />
                    <meta property="og:description" content="Try the #1 learn-to-code app for kids ages 3-10. Used by over 20 million kids worldwide, kids learn coding basics with puzzles and build skills to make their own games." />
                    <meta name="twitter:card" content="app" />
                    <meta name="twitter:site" content="@codesparkapp" />
                    <meta name="twitter:description" content="Try the #1 learn-to-code app for kids 4+. Used by over 20 Million kids, codeSpark teaches coding basics through creative play and game creation. Coding improves STEM, reading, and math skills." />
                    <meta name="twitter:app:country" content="US" />
                    <meta name="twitter:app:id:iphone" content="923441570" />
                    <meta name="twitter:app:id:ipad" content="923441570" />
                    <meta name="twitter:app:id:googleplay" content="org.codespark.thefoos" />
                </Helmet>
                <PageHeader text="Homeschooling" />
                <div className="homeschool-coming-soon">PAGE COMING SOON!</div>
                <div className="grid-x grid-padding-x align-center intro-section">
                    <div className="small-12 large-9 cell homeschool-img">
                        <img src="https://d2bqrn11jthp5j.cloudfront.net/dashboard/images/resources_icon_standards_v2.png" alt="" />
                    </div>
                    <div className="small-12 large-9 cell intro-text">
                        <h1 className="sub-header">Turning Programming into Play</h1>
                        <p>
                            codeSpark&rsquo;s mission is to make computer science education accessible to
                            kids everywhere.
                        </p>
                    </div>
                </div>
                <div className="grid-x grid-padding-x align-center intro-points">
                    <div className="intro-point-single">
                        <img src={`${imgURL}/flagship/about/book.png`} alt="" />
                        <p className="title">No Reading Requirement</p>
                        <p className="description">Our word-free interface<br />makes learning to code accessible to pre-readers and non-English speakers.</p>
                    </div>
                    <div className="intro-point-single">
                        <img src={`${imgURL}/flagship/about/superfoo.png`} alt="" />
                        <p className="title">Closing the Gender Gap</p>
                        <p className="description">Game mechanics that increase engagement in girls by 20% plus kick-butt girl characters in aspirational professions.</p>
                    </div>
                    <div className="intro-point-single">
                        <img src={`${imgURL}/flagship/about/schoolhouse.png`} alt="" />
                        <p className="title">Discounts For Homeschools</p>
                        <p className="description">codeSpark is proud to offer discounts to homeschools. Info: <a href="mailto:support@codespark.com">support@codespark.com</a> </p>
                    </div>
                </div>
                <div className="grid-x grid-padding-x align-center believe-section">
                    <div className="small-12 cell believe-header">
                        <h1 className="sub-header alt-blue">What We Believe</h1>
                    </div>
                    <div className="small-12 cell believe-points">
                        <div className="believe-point-single">
                            <img src={`${imgURL}/flagship/about/believe_1.png`} alt="" />
                            <p className="title">The Magic of Ingenuity</p>
                            <p className="description">
                                We think the pursuit of ingenious solutions brings together a perfect blend
                                of invention, creativity and originality.
                            </p>
                        </div>
                        <div className="believe-point-single">
                            <img src={`${imgURL}/flagship/about/believe_2.png`} alt="" />
                            <p className="title">The Power of Confidence</p>
                            <p className="description">
                                We foster the confidence it takes to stretch limits, persevere and stay curious.
                                We all benefit from knowing how to be fearless learners.
                            </p>
                        </div>
                        <div className="believe-point-single">
                            <img src={`${imgURL}/flagship/about/believe_3.png`} alt="" />
                            <p className="title">The Freedom to Experiment</p>
                            <p className="description">
                                We invite constant exploration and embrace the what ifs. We admire willingness to try
                                and believe having permission to fail is liberating.
                            </p>
                        </div>
                        <div className="believe-point-single">
                            <img src={`${imgURL}/flagship/about/believe_4.png`} alt="" />
                            <p className="title">The Wonder of Childhood</p>
                            <p className="description">
                                Wonder, curiosity and silliness are baked in to everything we make.<br />Kid-ness is goodness
                            </p>
                        </div>
                        <div className="believe-point-single">
                            <img src={`${imgURL}/flagship/about/believe_5.png`} alt="" />
                            <p className="title">The Power of Raising the Bar</p>
                            <p className="description">
                                We think high expectations are a sign of respect, so we approach kids as the
                                sophisticated thinkers they&rsquo;re proven to be.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="grid-x grid-padding-x align-center get-in-touch">
                    <div className="small-12 cell">
                        <img src={`${imgURL}/flagship/about/all_foos.jpg`} alt="" />
                        <h1>Want to get in touch?</h1>
                        <a href="/contact">Contact Us</a>
                    </div>
                </div>
            </div>
        );
    }
}

Homeschool.contextTypes = {
    mixpanel: PropTypes.object
};

export default props => (
    <Curious>
        {({ router, response, navigation }) => {
            return <Homeschool router={ router } response={ response } { ...props } />;
        }}
    </Curious>
);



// WEBPACK FOOTER //
// ./src/containers/Homeschool/index.js